import { render, staticRenderFns } from "./index_gt.vue?vue&type=template&id=0c83f25a&scoped=true"
import script from "./index_gt.vue?vue&type=script&lang=js"
export * from "./index_gt.vue?vue&type=script&lang=js"
import style0 from "./index_gt.scss?vue&type=style&index=0&id=0c83f25a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83f25a",
  null
  
)

export default component.exports